import store from '@/store'
import { realEstatesService } from '@/services/realEstates.service'
import { proPersonalAssetsRoute } from '@/router/routes/contants'

// Garde des écrans de suivi patrimonial (opérations, synchronisation bancaire, documents).
// Une agence (abonné Horiz Pro) SANS AUCUN BIEN est envoyée vers l'invitation à un compte
// particulier : l'abonnement Pro sert à l'activité d'agence. Une agence qui gère déjà des biens
// garde l'accès, et un particulier passe sans contrôle (son garde habituel s'applique ensuite).
//
// IMPORTANT (Vue Router 4) : NE PAS déclarer le paramètre `next` (cf edlBeforeEnter.js).
export const proWithoutRealEstatesBeforeEnter = async () => {
  if (!store.getters['auth/isPro']) {
    return true
  }

  const { count } = await realEstatesService.getRealEstateNumber()

  return count > 0 ? true : proPersonalAssetsRoute.path
}
